<template>
  <div class="s_ptb0lr24 s_bf">
    <div class="fz-18 s_hei60 s_ptb0lr24 s_flex_ali s_bf58">
      <a-button size='small' @click="()=>{$router.go(-1)}" class="mr10"><LeftOutlined />返回</a-button>
      {{$route.query.name}}
    </div>
  </div>
  <a-card :bordered='false'>
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'400px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="qr_code_sn">二维码编号</a-select-option>
            <a-select-option value="product_name" v-if="$route.query.type !== 'goods'">商品名称</a-select-option>
            <a-select-option value="product_sn" v-if="$route.query.type !== 'goods'">商品编号</a-select-option>
            <a-select-option value="production_batch_sn">批次号</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="扫码时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      <template v-slot:action="{ record }">
        <a @click="()=> {$router.push('/antiFleeingGoods/marketAudit/warningDetails?id='+record.dealer_id)}"
          href="javascript:;">查看全部记录</a>
      </template>
    </a-table>
    <div class="s_flex_bian_c m-t-20">
      <a-button class="width-100" block @click="()=>{$router.go(-1)}">返回</a-button>
      <a-pagination :style="{textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
  </a-card>
</template>
<script>
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import { fleeingWarningDealerMore,fleeingWarningProductMore,fleeingWarningOutMore } from "@/api/antiFleeing";
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    page: 1,
    limit: 10,
    key_type: "qr_code_sn",
    keyword: "",
  };
  export default {
    components: {LeftOutlined},
    setup() {
      const state = reactive({
        time: [],
        columns: [
          {
            title: "二维码编号",
            dataIndex: "qr_code_sn",
            key: "qr_code_sn",
          },
          {
            title: "批次号",
            dataIndex: "production_batch_sn",
            key: "production_batch_sn",
          },
          {
            title: "商品编号",
            dataIndex: "product_sn",
            key: "product_sn",
            width:120
          },
          {
            title: "商品名称",
            dataIndex: "product_name",
            key: "product_name",
          },
          {
            title: "商品规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "消费者昵称",
            dataIndex: "scan_user",
            key: "scan_user",
            width:120
          },
          {
            title: "扫码位置",
            dataIndex: "scan_wz",
            key: "scan_wz",
          },
          {
            title: "扫码时间",
            dataIndex: "scan_time",
            key: "scan_time",
          }
        ]
      });
      const $router = inject("$router");
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };

      onMounted(() => {
        let api
        if($route.query.type == 'goods'){
          api = fleeingWarningProductMore 
          state.columns.splice(2,3,{
            title: "经销商编号",
            dataIndex: "dealer_sn",
            key: "dealer_sn",
          },{
            title: "所属经销商",
            dataIndex: "dealer_name",
            key: "dealer_name",
          },{
            title: "经销商级别",
            dataIndex: "dealer_level_name",
            key: "dealer_level_name",
          },)
        }
        if($route.query.type == 'order'){
          api = fleeingWarningOutMore 
          state.columns.splice(1,4,{
            title: "商品名称",
            dataIndex: "product_name",
            key: "product_name",
            width:250
          },{
            title: "商品规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },{
            title: "所属经销商",
            dataIndex: "dealer_name",
            key: "dealer_name",
            width:200
          },)
        }
        if($route.query.type == 'dealer'){
          api = fleeingWarningDealerMore 
        }
        tableHoosks.initData(api, {...search.value,id:$route.query.id});
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        changTime
      };
    },
  };
</script>